import redux from '../../Images/techIcons/redux.svg'
import reactjs from '../../Images/techIcons/reactjs.svg'
import nodejs from '../../Images/techIcons/nodejs.svg'
import mongo from '../../Images/techIcons/mongo.svg'
import javascript from '../../Images/techIcons/javascript.svg'
import html from '../../Images/techIcons/html.svg'
import css from '../../Images/techIcons/css.svg'
import express from '../../Images/techIcons/express.svg'
import typescript from '../../Images/techIcons/typescript.svg'
import nextjs from '../../Images/techIcons/nextjs.svg'
import angular from '../../Images/techIcons/angular.svg'


export const techSvgArray = [
  {src: redux, name: 'REDUX'},
  {src: reactjs , name: 'REACTJS'},
  {src: nodejs, name: 'NODEJS'},
  {src: mongo, name: 'MongoDB'},
  {src: javascript, name: 'JAVASCRIPT'},
  {src: html, name: 'HTML'},
  {src: css, name: 'CSS'},
  {src: express, name: 'EXPRESS'},
  {src: typescript, name: 'TYPESCRIPT'},
  {src: nextjs, name: 'NEXTJS'},
  {src: angular, name: 'ANGULAR'},

]
